import notificationsClient from '@/axiosClients/notificationsClient'
import {errorHttpMessage} from '@/utils/errorDecodeUtil.js'

export const getNotifications = async ({commit}, date = null) => {
    try {
        const url = (date !== null && date !== '') ? `/notifications?date=${date}` : `/notifications`

        const {data: result} = await notificationsClient.get(url)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message.message,
            error_keys: error_http_message.error_keys,
            data: ex.response.data,
            error: true
        }
    }
}

export const setNotificationSeen = async ({commit}, notification_id) => {
    try {
        const {data: result} = await notificationsClient.post(`/notifications/seen?notification_id=${notification_id}`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message.message,
            error_keys: error_http_message.error_keys,
            data: ex.response.data,
            error: true
        }
    }
}

export const markAllNotificationsAsRead = async ({commit}) => {
    try {
        const {data: result} = await notificationsClient.post(`/notifications/seen-all?status=last`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message.message,
            error_keys: error_http_message.error_keys,
            data: ex.response.data,
            error: true
        }
    }
}

// Nuevas acciones para notificaciones del sistema
export const getUnacknowledgedNotifications = async ({commit}) => {
    try {
        const {data: result} = await notificationsClient.get('/system-notifications/unacknowledged')
        const {success, data, count} = result

        if (success) {
            commit('setUnacknowledgedNotifications', data)
            commit('setNotificationsCount', count)
            return {data, count, error: false}
        } else {
            commit('setUnacknowledgedNotifications', [])
            commit('setNotificationsCount', 0)
            return {data: [], count: 0, error: true, message: 'Error al obtener notificaciones'}
        }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setUnacknowledgedNotifications', [])
        commit('setNotificationsCount', 0)
        return {data: [], count: 0, error: true, message: error_http_message.message}
    }
}

export const markNotificationAcknowledged = async ({commit}, notificationId) => {
    try {
        const {data: result} = await notificationsClient.post('/system-notifications/mark-acknowledged', {
            notification_id: notificationId
        })
        const {success, message} = result

        if (success) {
            commit('removeNotification', notificationId)
            return {error: false, message}
        } else {
            return {error: true, message: 'Error al marcar notificación como leída'}
        }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {error: true, message: error_http_message.message}
    }
}

